import connectTransport from "../connect"
import ToHkustPage from "./ToHkustPage"

export default connectTransport(ToHkustPage)
